import {
  BMI_30_CHECK,
  CLINICAL_NUTRITION,
  COACHING_STYLE,
  DIABETES_NUTRITION,
  DIABETES_VIDEO,
  DIETARY,
  GLP1_NUTRITION,
  GLP1_VIDEO,
  HAS_DIABETES,
  HAS_GLP1,
  IS_MALE_2,
  NEXT_MALE_2,
  PRODUCT_BRANCHING,
  PRODUCT_UNSURE,
  RECIPE_FILTER_RESULTS,
  SHOW_IF_BMI_LESS_30,
  START_DIABETES_BRANCH,
  UNSURE_MEDS
} from "config/tags";
import { OBESE_BMI } from "utils/eligibility";
import { findAnswerByQuestionTag } from "utils/questions";

export const uni5Routing = ({
  nextUrlPath: nextUrlPathInit,
  question,
  answers,
  assessment,
  routes,
  profile
}) => {
  let nextUrlPath = nextUrlPathInit;

  // Show diabetes branch if user has diabetes.
  if (question.tags.includes(PRODUCT_BRANCHING)) {
    const productBranchingAnswer = findAnswerByQuestionTag(
      PRODUCT_BRANCHING,
      answers,
      assessment.questions
    );
    const hasDiabetesAnswer = findAnswerByQuestionTag(
      HAS_DIABETES,
      answers,
      assessment.questions
    );
    const startDiabetesBranch = assessment.questions.find(q =>
      q.tags.includes(START_DIABETES_BRANCH)
    ).urlPath;

    if (hasDiabetesAnswer === "Yes" && productBranchingAnswer === "No") {
      nextUrlPath = routes.question(startDiabetesBranch);
    }
  }

  // Show diabetes branch if user has diabetes.
  if (question.tags.includes(PRODUCT_UNSURE)) {
    const productUnsureAnswer = answers.find(a =>
      a?.answers?.[0]?.tags.includes(UNSURE_MEDS)
    )?.answers[0].value;
    const hasDiabetesAnswer = findAnswerByQuestionTag(
      HAS_DIABETES,
      answers,
      assessment.questions
    );
    const startDiabetesBranch = assessment.questions.find(q =>
      q.tags.includes(START_DIABETES_BRANCH)
    ).urlPath;

    if (hasDiabetesAnswer === "Yes" && productUnsureAnswer === "No") {
      nextUrlPath = routes.question(startDiabetesBranch);
    }
  }

  if (question.tags.includes(DIETARY)) {
    const productBranchingAnswer = findAnswerByQuestionTag(
      PRODUCT_BRANCHING,
      answers,
      assessment.questions
    );
    const hasGlp1Answer = findAnswerByQuestionTag(
      HAS_GLP1,
      answers,
      assessment.questions
    );
    const productUnsureAnswer = answers.find(a =>
      a?.answers?.[0]?.tags.includes(UNSURE_MEDS)
    )?.answers[0].value;

    // If user is taking GLP1, show GLP1 nutrition question.
    if (hasGlp1Answer === "Yes") {
      const glp1Nutrition = assessment.questions.find(q =>
        q.tags.includes(GLP1_NUTRITION)
      ).urlPath;

      nextUrlPath = routes.question(glp1Nutrition);
    }

    // If user said "Yes" to clinical, show clinical nutrition question.
    if (productBranchingAnswer === "Yes" || productUnsureAnswer === "Yes") {
      const clinicalNutrition = assessment.questions.find(q =>
        q.tags.includes(CLINICAL_NUTRITION)
      ).urlPath;

      nextUrlPath = routes.question(clinicalNutrition);
    }
  }

  // If user has diabetes, show diabetes nutrition question.
  if (question.tags.includes(RECIPE_FILTER_RESULTS)) {
    const hasDiabetesAnswer = findAnswerByQuestionTag(
      HAS_DIABETES,
      answers,
      assessment.questions
    );
    const diabetesNutrition = assessment.questions.find(q =>
      q.tags.includes(DIABETES_NUTRITION)
    ).urlPath;

    if (hasDiabetesAnswer === "Yes") {
      nextUrlPath = routes.question(diabetesNutrition);
    }
  }

  // Check if the user's BMI is 29.5 or lower. If so, show relevant questions.
  if (question.tags.includes(BMI_30_CHECK)) {
    if (profile.bmi <= OBESE_BMI) {
      const questionLess30Bmi = assessment.questions.find(q =>
        q.tags.includes(SHOW_IF_BMI_LESS_30)
      ).urlPath;
      nextUrlPath = routes.question(questionLess30Bmi);
    }
  }

  // If user is male, skip breastfeeding question.
  if (question.tags.includes(IS_MALE_2)) {
    if (profile.gender === "M") {
      nextUrlPath = routes.question(
        assessment.questions.find(q => q.tags.includes(NEXT_MALE_2)).urlPath
      );
    }
  }

  // Go to correct video question.
  if (question.tags.includes(COACHING_STYLE)) {
    const hasDiabetesAnswer = findAnswerByQuestionTag(
      HAS_DIABETES,
      answers,
      assessment.questions
    );
    const hasGlp1Answer = findAnswerByQuestionTag(
      HAS_GLP1,
      answers,
      assessment.questions
    );

    const diabetesVideo = assessment.questions.find(q =>
      q.tags.includes(DIABETES_VIDEO)
    ).urlPath;
    const glp1Video = assessment.questions.find(q =>
      q.tags.includes(GLP1_VIDEO)
    ).urlPath;

    if (hasGlp1Answer === "Yes") {
      nextUrlPath = routes.question(glp1Video);
    } else if (hasDiabetesAnswer === "Yes") {
      nextUrlPath = routes.question(diabetesVideo);
    }
  }

  return nextUrlPath;
};
